const MAP = {
  placed: { label: "New", cls: "bg-brand-primary text-white" },
  accepted: { label: "Accepted", cls: "bg-[#3a5f8a] text-white" },
  preparing: { label: "Preparing", cls: "bg-brand-cooking text-white" },
  ready: { label: "Ready", cls: "bg-brand-ready text-white" },
  out_for_delivery: { label: "Out for Delivery", cls: "bg-[#7a5cb0] text-white" },
  completed: { label: "Completed", cls: "bg-brand-muted text-white" },
  cancelled: { label: "Cancelled", cls: "bg-brand-alert text-white" },
  paid: { label: "Paid", cls: "bg-brand-ready text-white" },
  partial: { label: "Partial", cls: "bg-brand-cooking text-white" },
  unpaid: { label: "Unpaid", cls: "bg-brand-alert text-white" },
  credit: { label: "On Credit", cls: "bg-[#3a5f8a] text-white" },
};

export function StatusBadge({ status }) {
  const s = MAP[status] || MAP.placed;
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-sm text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap ${s.cls}`}>
      {s.label}
    </span>
  );
}
